module.exports = __webpack_public_path__ + "img/none.0fb8ae92.jpg";